module.exports = __webpack_public_path__ + "media/images/classpoints/brands/Y6-0b054f02bfb306de6d688ab2e93431cb.svg";